<template>
  <load v-if="loading" mode="table" message="Cadastrando usuário." />
  <div v-else>
    <form @submit.prevent="submit" ref="addItem">
      <div class="row">
        <form-input
          v-model="item.nome_completo"
          grid="8"
          label="Nome Completo"
          :required="true"
          ajuda="Não será permitido acentos ou caracteres especiais neste campo."
        />
        <form-input
          v-model="item.data_nascimento"
          grid="4"
          v-mask="'##/##/####'"
          label="Data de Nascimento"
          :required="is_situacao_rua"
        />
        <form-toggle
          v-model="showfiltroNomeSocial"
          grid="12"
          label="Deseja adicionar Nome Social?"
        />
        <template v-if="showfiltroNomeSocial">
          <form-input grid="6" v-model="item.nome_social" label="Nome Social" />

          <form-select
            grid="6"
            v-model="item.origem_nome_social"
            :itens="$root.arrays.origem_nome_social"
            label="Origem do Nome Social"
          />
        </template>
        <form-select
          v-model="item.estado_civil"
          grid="6"
          label="Estado Civil"
          :itens="$root.arrays.estado_civil"
          :required="is_situacao_rua"
        />
        <form-select
          v-model="item.posicao_familiar"
          :required="true"
          grid="6"
          label="Posição familiar"
          :itens="
            familia.responsavel_familiar
              ? $root.arrays.posicao_familiar_sr
              : $root.arrays.posicao_familiar
          "
        />

        <form-select
          v-model="item.sexo"
          grid="6"
          label="Sexo"
          :itens="$root.arrays.sexo"
          :required="true"
        />

        <form-select
          v-model="item.cor_raca"
          grid="6"
          label="Cor ou Raça"
          :itens="$root.arrays.cor_raca"
        />

        <form-input v-model="item.mae" grid="6" label="Filiação 1" />
        <form-input v-model="item.pai" grid="6" label="Filiação 2" />

        <form-input
          v-model="item.telefone"
          grid="6"
          v-mask="'(##) # ####-####'"
          label="Telefone"
        />
        <form-input
          v-model="item.celular"
          grid="6"
          v-mask="'(##) # ####-####'"
          label="Celular/Whatsapp"
        />

        <form-toggle-group
          grid="5"
          v-model="item.documento.providenciar_documentacao"
          label="Necessidade de providenciar documentação civil"
          :itens="$root.arrays.providenciar_documentacao"
        />
        <div class="col-md-7 col-sm-12">
          <div class="row">
            <form-input
              v-model="item.documento.nis"
              grid="8"
              label="NIS"
              :required="true"
              :readonly="item.nao_sabe_nis == '1' ? true : false"
            />
            <form-toggle
              mt="3"
              class="pl-0 pt-4"
              grid="4"
              v-model="item.nao_sabe_nis"
              label="Não sabe"
            />
          </div>
          <div class="row">
            <form-input
              v-model="item.documento.cpf"
              grid="8"
              label="CPF"
              :required="true"
              :readonly="item.nao_sabe_cpf == '1' ? true : false"
              :minlength="14"
              :maxlength="14"
              v-mask="'###.###.###-##'"
            />
            <form-toggle
              mt="3"
              grid="4"
              class="pl-0 pt-4"
              v-model="item.nao_sabe_cpf"
              label="Não sabe"
            />
          </div>
        </div>
      </div>

      <div class="float-right mt-3">
        <button class="btn btn-sm btn-danger" @click="$emit('voltar')">
          <i class="mdi mdi-close" />
          {{ $t("Cancelar") }}
        </button>
        <button
          class="btn btn-sm btn-success btn-submit"
          data-style="zoom-in"
          type="submit"
        >
          <i class="mdi mdi-content-save" />
          {{ $t("Salvar") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["familia"],
  name: "Add",
  data() {
    return {
      loading: false,
      is_situacao_rua: false,
      item: { documento: {} },
      providenciar_documentacao: [],
      showfiltroNomeSocial: false,
    };
  },
  watch: {
    "item.nome_completo": function (val) {
      this.item.nome_completo = val
        .normalize("NFD")
        .replace(/([\u0300-\u036f])/g, "")
        .replace(/([^\w]+|\s+)/g, "-")
        .replace(/\-+/g, " ")
        .toUpperCase();
    },
  },
  mounted() {
    this.is_situacao_rua =
      this.familia.endereco && this.familia.situacao_rua == 1 ? false : true;
  },
  methods: {
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      this.loading = true;

      this.item.familia_id = this.familia.id;
      this.item.codigo_familiar = this.familia.codigo_familiar;

      // this.item.data_nascimento = moment(
      // 	this.item.data_nascimento,
      // 	"YYYY-MM-DD"
      // ).format("DD/MM/YYYY");

      // Send request
      axios
        .post("api/dashboard/usuarios", this.item)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: "Familiar cadastrado com sucesso.",
          });
          this.familia.familiares.push(response.data);

          // this.$router.push("/dashboard/usuarios");
          this.$emit("voltar");
          this.$emit("reload");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
